import { Avatar, IconButton, Link, Menu, MenuItem } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import { Fragment, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

function MemberMenu() {
  const dispatch = useDispatch()
  const { user } = useSelector(state => state.authSlice)
  const [anchor, setAnchor] = useState(null)

  const open = Boolean(anchor)
  const handleCloseMenu = () => { setAnchor(null) }

  const handleClickMenu = (event) => {
    setAnchor(event.currentTarget)
  }

  // Handle logout
  const handleLogout = () => {
    dispatch({ type: "Logout" })
  }

  return (
    <Fragment>
      <IconButton
        sx={{
          p: "2px",
          border: "2px solid",
          borderColor: "primary.main"
        }}
        size="small"
        onClick={handleClickMenu}
      >
        <Avatar
          sx={{
            width: "35px",
            height: "35px",
          }}
          src={user?.image}
        />
      </IconButton>

      <Menu
        sx={{
          mt: 0.5,
          ".MuiPaper-root": {
            borderRadius: "8px",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0px 0px 10px 0px #0000000a",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        anchorEl={anchor}
        onClose={handleCloseMenu}
      >
        <MenuItem
          sx={{
            px: 1,
            minWidth: "180px",
            justifyContent: "start"
          }}
          disableRipple
          onClick={handleCloseMenu}
        >
          <Link
            sx={{
              width: "100%",
              color: "other.color1"
            }}
            to="/dashboard"
            underline="none"
            component={NavLink}
          >Dashboard
          </Link>
        </MenuItem>
        <MenuItem
          sx={{
            px: 1,
            minWidth: "180px",
            justifyContent: "start"
          }}
          disableRipple
          onClick={handleCloseMenu}
        >
          <Link
            sx={{
              width: "100%",
              color: "other.color1"
            }}
            to="/settings"
            underline="none"
            component={NavLink}
          >Account Settings
          </Link>
        </MenuItem>
        <MenuItem
          sx={{
            px: 1,
            minWidth: "180px",
            justifyContent: "start"
          }}
          disableRipple
          onClick={handleCloseMenu}
        >
          <Link
            sx={{
              width: "100%",
              textAlign: "start",
              color: "other.color1",
            }}
            underline="none"
            component="button"
            onClick={handleLogout}
          >Logout
          </Link>
        </MenuItem>
      </Menu>
    </Fragment>
  )
}

export default MemberMenu